namespace Pages {
    export class PrintersPage {
        private readonly _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }
        async index() {
            return new PageViewResult("Printers/", {});
        }
        async add() {
            return new PageViewResult("Printers/add/", new Entities.Printer({
                name: "",
                location: "",
                ipAddress: ""
            }));
        }
        async insert({ model }: { model: Entities.Printer }) {

            await this._repository.saveDocument(model);

            return new PageActionResult(
                new PageActionBack(new PageActionEvent("printerChanged"))
            );
        }
        async edit({ id }: { id: string }) {
            const { document: printer } = await this._repository.getDocument<Entities.Printer>(id);

            return new PageViewResult("Printers/edit/", 
                printer
            );
        }

        async update({ id, model }: { id: string, model: Entities.Printer}) {

            await this._repository.saveDocument(model);

            return new PageActionResult(
                new PageActionBack(new PageActionEvent("printerChanged"))
            );
        }

        async delete({ id, model }: {id: string, model: Entities.Printer}) {
            await this._repository.deleteDocument(model.id);
            return new PageActionResult(
                new PageActionBack(new PageActionEvent("printerChanged"))
            );
        }
    }
}